import {get, post} from '../http';

const fetch = () => get('accessRetrieve');
const save = (id, data) => post('accessSave?id='+id, data);

export default {
  fetch,
  save
};
